import {BaseEntity} from './base-entity';

export type MeetingParticipantType =  'CONSENTED_SPOUSE' | 'VENDOR' | 'MORTGAGOR' | 'PURCHASER' | 'GUARANTOR'
    | 'REALESTATEAGENT' | 'OTHERPARTY_REALESTATEAGENT' | 'SURVEYOR' | 'OTHERPARTY_SOLICITOR' | 'MORTGAGE_SOLICITOR';

export class MeetingParticipant extends BaseEntity {
    id: number;
    participantIdOnMatter: number; // This can be contact.id for most matter participants or contactInfo.id for 'OTHERPARTY_SOLICITOR'
    meetingParticipantRole: string; //Always 'INVITEE'
    meetingParticipantType: MeetingParticipantType; // This is the matter participant role or 'OTHERPARTY_SOLICITOR'
    subContactIndex: number;
    deleted: boolean; // Backend doesn't filter the deleted meetingParticipant. UI uses this flag for filter and presents the warning message.
    virtualMeetingLink: string; //each participant has a unique meeting link
}
